(function($) {
	$(() => {
		// 1. Get a target element that you want to persist scrolling for (such as a modal/lightbox/flyout/nav).
		const targetElement = document.querySelector("#documentBody");

		$('.hamburger').on('click', function() {
			$(this).toggleClass('is-active');

			if ($('.hamburger').hasClass('is-active')) {
				bodyScrollLock.disableBodyScroll(targetElement);
			} else {
				bodyScrollLock.enableBodyScroll(targetElement);
			}
		});
	});
})(jQuery);
